import OnWaitlistPage from './OnWaitlistPage';
import { OnWaitlistPageProps, OnWaitlistPageValueProps } from './types';

export type { OnWaitlistPageProps, OnWaitlistPageValueProps };
export default OnWaitlistPage;
